import React, { useState } from 'react';
import './RsvpForm.css';

function RsvpForm({ onSubmit, disabled = false }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    guestCount: 1,
    message: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error for this field if it exists
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validateField = (name, value) => {
    let error = null;
    
    switch(name) {
      case 'firstName':
        if (!value.trim()) error = 'First name is required';
        break;
      case 'lastName':
        if (!value.trim()) error = 'Last name is required';
        break;
      case 'email':
        if (value && !/\S+@\S+\.\S+/.test(value)) error = 'Invalid email format';
        break;
      case 'guestCount':
        if (value < 1) error = 'At least 1 guest required';
        break;
      default:
        break;
    }
    
    return error;
  };

  const validateForm = () => {
    const fields = ['firstName', 'lastName', 'guestCount'];
    const newErrors = {};
    
    fields.forEach(field => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });
    
    // Email is optional but must be valid if provided
    if (formData.email) {
      const error = validateField('email', formData.email);
      if (error) {
        newErrors.email = error;
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Call onSubmit with the form data
      onSubmit(formData);
      
      // Clear form if not in disabled mode (edit mode)
      if (!disabled) {
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          guestCount: 1,
          message: ''
        });
      }
    }
  };

  return (
    <div className="rsvp-form-container">
      <h2>RSVP</h2>
      <p>Please fill out this form to confirm your attendance</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName">First Name*</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className={errors.firstName ? 'error' : ''}
              disabled={disabled}
              placeholder="Enter first name"
            />
            {errors.firstName && <span className="error-message">{errors.firstName}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="lastName">Last Name*</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className={errors.lastName ? 'error' : ''}
              disabled={disabled}
              placeholder="Enter last name"
            />
            {errors.lastName && <span className="error-message">{errors.lastName}</span>}
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
              disabled={disabled}
              placeholder="Enter email address"
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={disabled}
              placeholder="Enter phone number"
            />
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="guestCount">Number of Guests*</label>
          <input
            type="number"
            id="guestCount"
            name="guestCount"
            min="1"
            value={formData.guestCount}
            onChange={handleChange}
            className={errors.guestCount ? 'error' : ''}
            disabled={disabled}
          />
          {errors.guestCount && <span className="error-message">{errors.guestCount}</span>}
        </div>
        
        <div className="form-group">
          <label htmlFor="message">Message (Optional)</label>
          <textarea
            id="message"
            name="message"
            rows="3"
            value={formData.message}
            onChange={handleChange}
            disabled={disabled}
            placeholder="Any additional information or special requests"
          ></textarea>
        </div>
        
        <button type="submit" className="submit-rsvp" disabled={disabled}>
          Submit RSVP
        </button>
        
        {disabled && (
          <div className="form-mode-message">
            <p>This form is in preview mode. Form submissions will be enabled when the invitation is published.</p>
          </div>
        )}
      </form>
    </div>
  );
}

export default RsvpForm; 